export enum StripeSubscriptionStatus {
    ACTIVE = 'ACTIVE',
    PENDING_CANCELLATION = 'PENDING_CANCELLATION',
    CANCELLED = 'CANCELLED'
}